import { SendPOSTUserAPI } from "./Api.js";


export const SetStoreLoginedValues = (store, isLogined, router) => {
    if (isLogined) {
        store.commit('setIsLoginedMutation', true);
        store.commit('setShowNavbarMutation', true);
        return;
    }

    store.commit('setAllSecurityValuesNullMutation')
    store.commit('setAllLayoutValuesNullMutation')
    store.commit('setAllProjectsMutation', [])

    localStorage.removeItem('user')
    localStorage.removeItem('rToken')
    localStorage.removeItem('apiRefreshToken')
    router.push({ path: 'signin' })
}

export const LoggedIn = async (store, router) => {
    try {
        const getUserDataFromStorage = localStorage.getItem("user");
        if (getUserDataFromStorage)
            store.commit('setUserDataMutation', JSON.parse(getUserDataFromStorage));

        if (localStorage.getItem("rToken") === null) return { isOk: false };
        if (!store.getters.getAccessToken || !store.getters.getAuthHeaderForServerAPIRequest) {
            const atResponse = await GetAccessToken(store, router);

            if (!atResponse.isOk) {
                return { isOk: false };
            }
        }

        return {
            isOk: true,
        };
    } catch (e) {
        console.log(e, 'LoggedIn exception');
        return { isOk: false };
    }
}

export const GetAccessToken = async (store, router) => {
    const refreshToken = localStorage.getItem("rToken");

    if (!refreshToken) {
        SetStoreLoginedValues(store, false, router);
    }

    if (store.getters.getAccessToken)
        return { isOk: true, accessToken: store.getters.getAccessToken };

    try {
        const body = {
            username: store.getters.getUserData.email,
            refreshToken: refreshToken,
        };
        store.commit("setShowPreloader", true)
        const response = await SendPOSTUserAPI("refresh-token", null, body);
        if (!response || !response.accessToken) {
            return { isOk: false, message: "Wrong Token. Please relogin." };
        }

        store.commit('setAccessTokenMutation', response.accessToken);
        store.commit('setAuthHeaderForServerAPIRequestMutation', {
            Authorization: "Bearer " + store.getters.getAccessToken,
        })
        store.commit("setShowPreloader", false)
        return {
            isOk: true,
            accessToken: store.getters.getAccessToken,
        };
    } catch (e) {
        console.log(e, 'GetAccessToken exception')
        store.commit("setShowPreloader", false)
        return {
            isOk: false
        };
    }
}